import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@telus/koodo-ui-kit'

// Use kit Typography only for token-driven cases; plain headings preserve
// legacy className behavior across existing screens.
const Heading3 = ({
  id, children, className, tokens, variant
}) => {
  if (!tokens) {
    return (
      <h3 className={`text-lg leading-none tracking-wide text-h3 font-h3 ${className || ''}`} id={id}>
        {children}
      </h3>
    )
  }

  return (
    <div className={className} id={id}>
      <Typography block heading="h3" variant={variant} tokens={tokens}>
        {children}
      </Typography>
    </div>
  )
}

Heading3.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  tokens: PropTypes.shape({}),
  variant: PropTypes.shape({})
}

Heading3.defaultProps = {
  variant: { size: 'h3' }
}

export default Heading3
